import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material'
import styled from 'styled-components'
import { COLORS } from 'utils'

export const FormDialog = styled.form``
export const DialogStyled = styled(Dialog)``
export const DialogTitleStyled = styled(DialogTitle)`
  color: ${COLORS.black};
`
export const DialogContentStyled = styled(DialogContent)``
export const DialogActionsStyled = styled(DialogActions)``

export const RollStamp = styled.div`
  border-radius: 50px;
  margin-top: -20px;
  margin-bottom: 20px;
  border-width: 4px;
  border-style: solid;
  border-color: #2f49d0;
  height: 90px;
  width: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
`
